import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import {
  HeaderSection,
  MainSection,
  SubHeaderSection,
  QuizHeader,
  HtmlView as SKHtmlView,
} from '@skooldio/skooldio-classroom-components';
import { useMediaQuery } from '@material-ui/core';

import { useConfig } from 'Context/ConfigContext';
import QuizWrapper from 'Components/Quiz/Components/QuizWrapper';
import {
  ActionBox,
  QuizContentWrapper,
  QuizDivider,
  QuizFooterWrapper,
  QuizLayoutWrapper,
} from 'Components/Quiz/Components/QuizBox';
import { useOffset } from 'Context/LayoutContext/OffsetProvider';
import { useScrollIndicator } from 'Util/Hooks';
import ScrollSeeMoreWrapper from 'Components/ScrollSeeMoreWrapper';

import { Box, Text } from '../../../../Base';
import { RESULT_TYPE } from '../constant';

import {
  getHeaderText,
  HTMLView,
  LatexWrapper,
  QuizInnerLayout,
  SelectedChoice,
  TitleBar,
} from './SolutionDetail.view';

const SolutionDetailWithPassage = ({
  variant,
  result,
  solutionContent,
  onBack,
  onNextQuestion,
  onPreviousQuestion,
  isLastQuestion,
  isFirstQuestion,
  selectedAnswer,
  questionNo,
  questionContent,
  isShowScore,
  score,
  passage,
}) => {
  const {
    classroom: { quiz = {} },
  } = useConfig();
  const { bgColor = 'primary' } = quiz;
  const { colors, breakpoints } = useTheme();
  const { bottomOffset } = useOffset();
  const isDesktop = useMediaQuery(`(min-width:${breakpoints?.lg ?? '1024px'})`);

  const Wrapper = isDesktop ? QuizContentWrapper : Box;

  const { showIndicator, wrapperRef, onScroll } = useScrollIndicator();

  return (
    <QuizWrapper subHeader>
      <HeaderSection>
        <QuizHeader
          title={getHeaderText(variant)}
          backIcon={true}
          onBack={onBack}
          outerWrapperProps={{ bg: colors[bgColor] }}
        />
      </HeaderSection>
      <SubHeaderSection>
        <TitleBar questionNo={questionNo} result={result} isShowScore={isShowScore} score={score} />
      </SubHeaderSection>
      <MainSection>
        <QuizInnerLayout>
          <Box>
            <QuizLayoutWrapper isDesktop={isDesktop}>
              <ScrollSeeMoreWrapper isShowScrollDown={showIndicator}>
                <QuizContentWrapper
                  ref={wrapperRef}
                  onScroll={onScroll}
                  height={isDesktop ? '72vh' : '28vh'}
                >
                  <Box pb={8}>
                    <Text textStyle="subtitle1" mb={3} pt={3}>
                      {'บทความ'}
                    </Text>
                    <LatexWrapper>
                      <SKHtmlView>{passage}</SKHtmlView>
                    </LatexWrapper>
                  </Box>
                </QuizContentWrapper>
              </ScrollSeeMoreWrapper>
              <QuizDivider isDesktop={isDesktop} />
              <Wrapper height={isDesktop ? '72vh' : '100%'} pb={isDesktop ? 8 : 0} pr={2}>
                {questionContent && (
                  <>
                    <Text textStyle="subtitle1" mb={3} pt={3}>
                      {'คำถาม'}
                    </Text>
                    <LatexWrapper>
                      <HTMLView rawContent={questionContent} />
                    </LatexWrapper>
                  </>
                )}
                <Text textStyle="subtitle1" pt={6} mb={3}>
                  {'คำตอบของคุณ'}
                </Text>
                <SelectedChoice selectedAnswer={selectedAnswer} />
                <Text textStyle="subtitle1" mt={6} mb={3}>
                  {'เฉลยละเอียด'}
                </Text>
                <LatexWrapper>
                  <HTMLView rawContent={solutionContent} />
                </LatexWrapper>
              </Wrapper>
            </QuizLayoutWrapper>
          </Box>
          <QuizFooterWrapper bottomOffset={bottomOffset}>
            <ActionBox
              style={{ height: '100%' }}
              onNext={onNextQuestion}
              onBack={onPreviousQuestion}
              isLastQuestion={isLastQuestion}
              isFirstQuestion={isFirstQuestion}
              nextButtonText={isLastQuestion ? 'ออก' : 'ข้อถัดไป'}
            />
          </QuizFooterWrapper>
        </QuizInnerLayout>
      </MainSection>
    </QuizWrapper>
  );
};

SolutionDetailWithPassage.propTypes = {
  solutionContent: PropTypes.string,
  result: PropTypes.oneOf(Object.values(RESULT_TYPE)),
  onBack: PropTypes.func,
  onNextQuestion: PropTypes.func,
  onPreviousQuestion: PropTypes.func,
  isFirstQuestion: PropTypes.bool,
  isLastQuestion: PropTypes.bool,
  questionNo: PropTypes.number,
  questionContent: PropTypes.string,
  isShowScore: PropTypes.bool,
  score: PropTypes.number,
  passage: PropTypes.string,
};

SolutionDetailWithPassage.defaultProps = {
  onBack: () => {},
  onNextQuestion: () => {},
  onPreviousQuestion: () => {},
};

export default SolutionDetailWithPassage;
